import React, { useContext } from 'react'
import { Link } from "react-router-dom";

import { TabContext } from '../../contexts/TabContext'


import './Footer.css'
import mec from '../../assets/png/mec.png'


function Footer() {
   
    const { updateDropdownTab } = useContext(TabContext);
    let year = new Date().getFullYear();

  return (
    <div className='footer'>
        <div className='footer_top'>
            <h1>Quick Links</h1>
            <div className='footer_top_content'>
                <Link to='faculty/login'>Faculty Login</Link>            
                <Link to='clubs/login'>Club Login</Link>            
                <a href="https://ktu.edu.in/" target='_blank' rel='noreferrer'>KTU</a>
                <a href="http://ihrd.ac.in/" target='_blank' rel='noreferrer'>IHRD</a>
                <a href="https://edu.ezygo.app/#/institute" target='_blank' rel='noreferrer'>EZYGO</a>
                <a href="https://moodle.mec.ac.in/" target='_blank' rel='noreferrer'>MOODLE</a>
            </div>
        </div>
        <div className='footer_container'>
            <div className='footer_logo'>
                <a href='http://www.mec.ac.in/' target='_blank' rel="noreferrer">
                    <img className='footer_img' src={mec} alt=" " />
                </a>
            </div>
            <div className='footer_links'>
                <div className='footer_link_section one'>
                    <Link to='academics'>Academics</Link>            
                    <Link to='people' onClick={() => {updateDropdownTab(2); window.scrollTo(0, 0)}}>Faculty</Link>     
                    <Link to='people' onClick={() => {updateDropdownTab(3); window.scrollTo(0, 0)}}>Students</Link>            
                </div>
                <div className='footer_link_section two'>
                    <Link to='placements' onClick={() => {updateDropdownTab(2); window.scrollTo(0, 0)}}>Placements</Link>     
                    <Link to='placements' onClick={() => {updateDropdownTab(3); window.scrollTo(0, 0)}}>Internships</Link>            
                    <Link to='activities' onClick={() => {updateDropdownTab(1); window.scrollTo(0, 0)}}>Achievements</Link>            
                </div>
                <div className='footer_link_section three'>
                    <Link to='activities' onClick={() => {updateDropdownTab(2); window.scrollTo(0, 0)}}>Clubs</Link>     
                    <Link to='activities' onClick={() => {updateDropdownTab(3); window.scrollTo(0, 0)}}>Projects</Link>                
                    <Link to='activities' onClick={() => {updateDropdownTab(4); window.scrollTo(0, 0)}}>Events</Link>
                </div>                
            </div>
            <div className='footer_contact'>
                <h1>Contact Us</h1>
                <p>
                    The HOD <br/>
                    Department of Computer Engineering <br/>
                    Model Engineering College<br/>
                    Thrikkakara, Kochi<br/>
                    Kerala, PIN: 682021<br/>
                    Contact: hodcs@mec.ac.in<br/>
                    Phone: 0484 2307127
                </p>
            </div>
        </div>
        <div className='footer_bottom'>
            <p>Managed by Institute of Human Resource Development    |    Established by Government of Kerala</p>
            <p>Copyright © {year}    |    <Link to='/team'>Credits</Link> </p>
        </div>
    </div>

  )
}

export default Footer